import * as React from 'react';

export const check = (): React.ReactElement => (
  <path
    d="M7.23,12.11l6.62-10.4a1.27,1.27,0,0,1,1.6-.45,1.09,1.09,0,0,1,.46,1.37v.11L8.48,14.28c-.22.46-.68.57-1.25.57a1,1,0,0,1-.69-.34L.26,8.8a1,1,0,0,1,0-1.37l.11-.12a1.12,1.12,0,0,1,1.6,0Z"
    style={{ fill: 'inherit' }}
  />
);

export default check;
